import {
  searchMembersCall,
  searchRoomsCall,
  searchStoriesCall,
  searchStoriesCommentsCall,
  searchPollsCall,
  searchPostsCall,
  searchRepliesCall,
} from './service';
import { createAppAsyncThunk } from '../store/extensions';

export const searchMembers = createAppAsyncThunk(
  'search/members',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
    roomId?: string;
    searchThrough?: number;
  }) => {
    return searchMembersCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken,
      args.roomId,
      args.searchThrough
    );
  }
);

export const searchRooms = createAppAsyncThunk(
  'search/rooms',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchRoomsCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);

export const searchPosts = createAppAsyncThunk(
  'search/posts',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchPostsCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);

export const searchReplies = createAppAsyncThunk(
  'search/replies',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchRepliesCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);

export const searchPolls = createAppAsyncThunk(
  'search/polls',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchPollsCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);

export const searchStories = createAppAsyncThunk(
  'search/stories',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchStoriesCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);

export const searchStoriesComments = createAppAsyncThunk(
  'search/storiesComments',
  (args: {
    searchString: string;
    numrecs?: number;
    xMsContinuationToken?: string;
  }) => {
    return searchStoriesCommentsCall(
      args.searchString,
      args.numrecs,
      args.xMsContinuationToken
    );
  }
);
